import { attachAsyncAppsFromManifest, getStagingVersionedUrl } from '@gohighlevel/ghl-module-federation-plugin'

import jenkinsConfig from '../../jenkins-config'

interface Config {
  onboardingApp: string
  launchpadApp: string
  membershipApp: string
  communitiesApp: string
  goKollabApp: string
  clientPortalBuilder: string
  certificatesApp: string
  snapshotsApp: string
  productsApp: string
  storeWidgetApp: string
  ecommerceApp: string
  aiEmployeesApp: string
  marketplaceApp: string
  appointmentModalApp: string
  mediaEditorApp: string
  emailPreviewApp: string
  calendarSettingsApp: string
  calendarServicesApp: string
  calendarRentalsApp: string
  powerDialerApp: string
  defaultEmailTemplatesApp: string
  contactsApp: string
  ghlContactRestoreApp: string
  agentStudioApp: string
  featureDiscoveryApp: string
  invoicesApp: string
  estimatesApp: string
  leadgenPaymentLinksApp: string
  invoicesIntegrationsApp: string
  labsApp: string
  documentsApp: string
  customFieldsApp: string
  bulkActionsApp: string
  locationSettingApp: string
  copilotApp: string
  opportunitiesApp: string
  formSurveyApp: string
  proposalsEstimatesApp: string
  proposalsEstimateTemplateApp: string
  conversationsUtilitiesApp: string
  crmObjectsSettingsApp: string
  usersApp: string
  knowledgeBaseApp: string
}

interface remoteConfigEnv {
  development: Config
  staging: Config
  interop: Config
  beta: Config
  production: Config
}

export interface remoteConfig {
  key: string
  url: string
  alias: string
}

const remoteConfigEnv: remoteConfigEnv = {
  development: {
    membershipApp: 'https://staging.appcdn.leadconnectorhq.com/revex/memberships/remoteEntry.js?nocache=true',
    communitiesApp: 'https://staging.appcdn.leadconnectorhq.com/revex/communities-builder/remoteEntry.js?nocache=true',
    goKollabApp: 'https://staging.appcdn.leadconnectorhq.com/revex/gokollab-builder/remoteEntry.js?nocache=true',
    clientPortalBuilder: 'https://staging.appcdn.leadconnectorhq.com/revex/clientportal-builder/remoteEntry.js',
    certificatesApp:
      'https://staging.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    snapshotsApp: 'https://staging.appcdn.leadconnectorhq.com/revex/snapshots/remoteEntry.js?nocache=true',
    productsApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/products/remoteEntry.js?nocache=true',
    storeWidgetApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/store-widgets/remoteEntry.js?nocache=true',
    ecommerceApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/ecommerce/remoteEntry.js?nocache=true',
    aiEmployeesApp: 'https://staging.appcdn.leadconnectorhq.com/crm/ai-employees/remoteEntry.js?nocache=true',
    marketplaceApp: 'https://staging.appcdn.leadconnectorhq.com/crm/marketplace/remoteEntry.js?nocache=true',
    powerDialerApp: 'https://staging.appcdn.leadconnectorhq.com/revex/power-dialer/remoteEntry.js?nocache=true',
    appointmentModalApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/appointment-modal/remoteEntry.js?nocache=true',
    mediaEditorApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/MediaEditor/remoteEntry.js?nocache=true',
    emailPreviewApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/email-preview/remoteEntry.js?nocache=true',
    calendarSettingsApp: 'https://staging.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    calendarServicesApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/calendar-services/remoteEntry.js?nocache=true',
    calendarRentalsApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/calendar-rentals/remoteEntry.js?nocache=true',
    onboardingApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/Onboarding/remoteEntry.js?nocache=true',
    defaultEmailTemplatesApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/default-emails/remoteEntry.js?nocache=true',
    contactsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true',
    ghlContactRestoreApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true',
    launchpadApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/Launchpad/remoteEntry.js?nocache=true',
    agentStudioApp: 'https://staging.appcdn.leadconnectorhq.com/ai/agent-studio/remoteEntry.js?nocache=true',
    featureDiscoveryApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/feature-discovery/remoteEntry.js?nocache=true',
    invoicesApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/invoices/remoteEntry.js?nocache=true',
    estimatesApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/estimates/remoteEntry.js?nocache=true',
    leadgenPaymentLinksApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/payment-links/remoteEntry.js?nocache=true',
    invoicesIntegrationsApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/invoices-integrations/remoteEntry.js?nocache=true',
    labsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/labs/remoteEntry.js?nocache=true',
    documentsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/documents/remoteEntry.js?nocache=true',
    customFieldsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/custom-fields/remoteEntry.js?nocache=true',
    bulkActionsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/bulk-actions/remoteEntry.js?nocache=true',
    locationSettingApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/LocationSetting/remoteEntry.js?nocache=true',
    copilotApp: 'https://staging.appcdn.leadconnectorhq.com/ai/copilot/remoteEntry.js?nocache=true',
    opportunitiesApp: 'https://staging.appcdn.leadconnectorhq.com/crm/opportunities/remoteEntry.js?nocache=true',
    formSurveyApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true',
    proposalsEstimatesApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/proposals/remoteEntry.js?nocache=true',
    proposalsEstimateTemplateApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/templates/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://staging.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    crmObjectsSettingsApp:
      'https://staging.appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true',
    usersApp: 'https://staging.appcdn.leadconnectorhq.com/crm/users/remoteEntry.js?nocache=true',
    knowledgeBaseApp: 'https://staging.appcdn.leadconnectorhq.com/ai/knowledge-base/remoteEntry.js?nocache=true',
  },
  staging: {
    membershipApp: 'https://staging.appcdn.leadconnectorhq.com/revex/memberships/remoteEntry.js?nocache=true',
    communitiesApp: 'https://staging.appcdn.leadconnectorhq.com/revex/communities-builder/remoteEntry.js?nocache=true',
    goKollabApp: 'https://staging.appcdn.leadconnectorhq.com/revex/gokollab-builder/remoteEntry.js?nocache=true',
    clientPortalBuilder: 'https://staging.appcdn.leadconnectorhq.com/revex/clientportal-builder/remoteEntry.js',
    certificatesApp:
      'https://staging.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    snapshotsApp: 'https://staging.appcdn.leadconnectorhq.com/revex/snapshots/remoteEntry.js?nocache=true',
    productsApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/products/remoteEntry.js?nocache=true',
    storeWidgetApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/store-widgets/remoteEntry.js?nocache=true',
    ecommerceApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/ecommerce/remoteEntry.js?nocache=true',
    aiEmployeesApp: 'https://staging.appcdn.leadconnectorhq.com/crm/ai-employees/remoteEntry.js?nocache=true',
    marketplaceApp: 'https://staging.appcdn.leadconnectorhq.com/crm/marketplace/remoteEntry.js?nocache=true',
    powerDialerApp: 'https://staging.appcdn.leadconnectorhq.com/revex/power-dialer/remoteEntry.js?nocache=true',
    appointmentModalApp:
    'https://staging.appcdn.leadconnectorhq.com/automation/appointment-modal/remoteEntry.js?nocache=true',
    mediaEditorApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/MediaEditor/remoteEntry.js?nocache=true',
    emailPreviewApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/email-preview/remoteEntry.js?nocache=true',
    calendarSettingsApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    calendarServicesApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/calendar-services/remoteEntry.js?nocache=true',
    calendarRentalsApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/calendar-rentals/remoteEntry.js?nocache=true',
    onboardingApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/Onboarding/remoteEntry.js?nocache=true',
    defaultEmailTemplatesApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/default-emails/remoteEntry.js?nocache=true',
    contactsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true',
    ghlContactRestoreApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true',
    launchpadApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/Launchpad/remoteEntry.js?nocache=true',
    agentStudioApp: 'https://staging.appcdn.leadconnectorhq.com/ai/agent-studio/remoteEntry.js?nocache=true',
    featureDiscoveryApp:
      'https://staging.appcdn.leadconnectorhq.com/automation/feature-discovery/remoteEntry.js?nocache=true',
    invoicesApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/invoices/remoteEntry.js?nocache=true',
    estimatesApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/estimates/remoteEntry.js?nocache=true',
    leadgenPaymentLinksApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/payment-links/remoteEntry.js?nocache=true',
    invoicesIntegrationsApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/invoices-integrations/remoteEntry.js?nocache=true',
    labsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/labs/remoteEntry.js?nocache=true',
    documentsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/documents/remoteEntry.js?nocache=true',
    customFieldsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/custom-fields/remoteEntry.js?nocache=true',
    bulkActionsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/bulk-actions/remoteEntry.js?nocache=true',
    locationSettingApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/LocationSetting/remoteEntry.js?nocache=true',
    copilotApp: 'https://staging.appcdn.leadconnectorhq.com/ai/copilot/remoteEntry.js?nocache=true',
    opportunitiesApp: 'https://staging.appcdn.leadconnectorhq.com/crm/opportunities/remoteEntry.js?nocache=true',
    formSurveyApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true',
    proposalsEstimatesApp: 'https://staging.appcdn.leadconnectorhq.com/leadgen/proposals/remoteEntry.js?nocache=true',
    proposalsEstimateTemplateApp:
      'https://staging.appcdn.leadconnectorhq.com/leadgen/templates/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://staging.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    crmObjectsSettingsApp:
      'https://staging.appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true',
    usersApp: 'https://staging.appcdn.leadconnectorhq.com/crm/users/remoteEntry.js?nocache=true',
    knowledgeBaseApp: 'https://staging.appcdn.leadconnectorhq.com/ai/knowledge-base/remoteEntry.js?nocache=true',
  },
  interop: {
    membershipApp: 'https://interop.appcdn.leadconnectorhq.com/revex/memberships/remoteEntry.js?nocache=true',
    communitiesApp: 'https://interop.appcdn.leadconnectorhq.com/revex/communities-builder/remoteEntry.js?nocache=true',
    goKollabApp:
      'https://interop.appcdn.leadconnectorhq.com/revex/gokollab-builder--ver--gokollab/remoteEntry.js?nocache=true',
    clientPortalBuilder: 'https://interop.appcdn.leadconnectorhq.com/revex/clientportal-builder/remoteEntry.js',
    certificatesApp:
      'https://interop.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    snapshotsApp: 'https://interop.appcdn.leadconnectorhq.com/revex/snapshots/remoteEntry.js?nocache=true',
    productsApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/products/remoteEntry.js?nocache=true',
    storeWidgetApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/store-widgets/remoteEntry.js?nocache=true',
    ecommerceApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/ecommerce/remoteEntry.js?nocache=true',
    aiEmployeesApp: 'https://interop.appcdn.leadconnectorhq.com/crm/ai-employees/remoteEntry.js?nocache=true',
    marketplaceApp: 'https://interop.appcdn.leadconnectorhq.com/crm/marketplace/remoteEntry.js?nocache=true',
    powerDialerApp: 'https://interop.appcdn.leadconnectorhq.com/revex/power-dialer/remoteEntry.js?nocache=true',
    appointmentModalApp:
      'https://interop.appcdn.leadconnectorhq.com/automation/appointment-modal/remoteEntry.js?nocache=true',
    mediaEditorApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/MediaEditor/remoteEntry.js?nocache=true',
    emailPreviewApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/email-preview/remoteEntry.js?nocache=true',
    calendarSettingsApp:
      'https://interop.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    calendarServicesApp:
      'https://interop.appcdn.leadconnectorhq.com/automation/calendar-services/remoteEntry.js?nocache=true',
    calendarRentalsApp:
      'https://interop.appcdn.leadconnectorhq.com/automation/calendar-rentals/remoteEntry.js?nocache=true',
    onboardingApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/Onboarding/remoteEntry.js?nocache=true',
    defaultEmailTemplatesApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/default-emails/remoteEntry.js?nocache=true',
    contactsApp: 'https://staging.appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true',
    ghlContactRestoreApp: 'https://interop.appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true',
    launchpadApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/Launchpad/remoteEntry.js?nocache=true',
    agentStudioApp: 'https://interop.appcdn.leadconnectorhq.com/ai/agent-studio/remoteEntry.js?nocache=true',
    featureDiscoveryApp:
      'https://interop.appcdn.leadconnectorhq.com/automation/feature-discovery/remoteEntry.js?nocache=true',
    invoicesApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/invoices/remoteEntry.js?nocache=true',
    estimatesApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/estimates/remoteEntry.js?nocache=true',
    leadgenPaymentLinksApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/payment-links/remoteEntry.js?nocache=true',
    invoicesIntegrationsApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/invoices-integrations/remoteEntry.js?nocache=true',
    labsApp: 'https://interop.appcdn.leadconnectorhq.com/crm/labs/remoteEntry.js?nocache=true',
    documentsApp: 'https://interop.appcdn.leadconnectorhq.com/crm/documents/remoteEntry.js?nocache=true',
    customFieldsApp: 'https://interop.appcdn.leadconnectorhq.com/crm/custom-fields/remoteEntry.js?nocache=true',
    bulkActionsApp: 'https://interop.appcdn.leadconnectorhq.com/crm/bulk-actions/remoteEntry.js?nocache=true',
    locationSettingApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/LocationSetting/remoteEntry.js?nocache=true',
    copilotApp: 'https://interop.appcdn.leadconnectorhq.com/ai/copilot/remoteEntry.js?nocache=true',
    opportunitiesApp: 'https://interop.appcdn.leadconnectorhq.com/crm/opportunities/remoteEntry.js?nocache=true',
    formSurveyApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true',
    proposalsEstimatesApp: 'https://interop.appcdn.leadconnectorhq.com/leadgen/proposals/remoteEntry.js?nocache=true',
    proposalsEstimateTemplateApp:
      'https://interop.appcdn.leadconnectorhq.com/leadgen/templates/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://interop.appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    crmObjectsSettingsApp:
      'https://interop.appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true',
    usersApp: 'https://interop.appcdn.leadconnectorhq.com/crm/users/remoteEntry.js?nocache=true',
    knowledgeBaseApp: 'https://interop.appcdn.leadconnectorhq.com/ai/knowledge-base/remoteEntry.js?nocache=true'
  },
  beta: {
    membershipApp: 'https://beta.appcdn.leadconnectorhq.com/revex/memberships/remoteEntry.js?nocache=true',
    communitiesApp: 'https://beta.appcdn.leadconnectorhq.com/revex/communities-builder/remoteEntry.js?nocache=true',
    goKollabApp: 'https://beta.appcdn.leadconnectorhq.com/revex/gokollab-builder/remoteEntry.js?nocache=true',
    clientPortalBuilder:
      'https://beta.appcdn.leadconnectorhq.com/revex/clientportal-builder/remoteEntry.js?nocache=true',
    certificatesApp: 'https://beta.appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    snapshotsApp: 'https://beta.appcdn.leadconnectorhq.com/revex/snapshots/remoteEntry.js?nocache=true',
    productsApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/products/remoteEntry.js?nocache=true',
    storeWidgetApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/store-widgets/remoteEntry.js?nocache=true',
    ecommerceApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/ecommerce/remoteEntry.js?nocache=true',
    aiEmployeesApp: 'https://beta.appcdn.leadconnectorhq.com/crm/ai-employees/remoteEntry.js?nocache=true',
    marketplaceApp: 'https://beta.appcdn.leadconnectorhq.com/crm/marketplace/remoteEntry.js?nocache=true',
    powerDialerApp: 'https://beta.appcdn.leadconnectorhq.com/revex/power-dialer/remoteEntry.js?nocache=true',
    appointmentModalApp:
      'https://beta.appcdn.leadconnectorhq.com/automation/appointment-modal/remoteEntry.js?nocache=true',
    mediaEditorApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/MediaEditor/remoteEntry.js?nocache=true',
    emailPreviewApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/email-preview/remoteEntry.js?nocache=true',
    onboardingApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/Onboarding/remoteEntry.js?nocache=true',
    launchpadApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/Launchpad/remoteEntry.js?nocache=true',
    calendarSettingsApp:
      'https://beta.appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    calendarServicesApp: 'https://beta.leadconnectorhq.com/automation/calendar-services/remoteEntry.js?nocache=true',
    calendarRentalsApp:
      'https://beta.appcdn.leadconnectorhq.com/automation/calendar-rentals/remoteEntry.js?nocache=true',
    defaultEmailTemplatesApp:
      'https://beta.appcdn.leadconnectorhq.com/leadgen/default-emails/remoteEntry.js?nocache=true',
    contactsApp: 'https://beta.appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true',
    ghlContactRestoreApp: 'https://beta.appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true',
    agentStudioApp: 'https://beta.appcdn.leadconnectorhq.com/ai/agent-studio/remoteEntry.js?nocache=true',
    featureDiscoveryApp:
      'https://beta.appcdn.leadconnectorhq.com/automation/feature-discovery/remoteEntry.js?nocache=true',
    invoicesApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/invoices/remoteEntry.js?nocache=true',
    estimatesApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/estimates/remoteEntry.js?nocache=true',
    leadgenPaymentLinksApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/payment-links/remoteEntry.js?nocache=true',
    invoicesIntegrationsApp:
      'https://beta.appcdn.leadconnectorhq.com/leadgen/invoices-integrations/remoteEntry.js?nocache=true',
    labsApp: 'https://beta.appcdn.leadconnectorhq.com/crm/labs/remoteEntry.js?nocache=true',
    documentsApp: 'https://beta.appcdn.leadconnectorhq.com/crm/documents/remoteEntry.js?nocache=true',
    customFieldsApp: 'https://beta.appcdn.leadconnectorhq.com/crm/custom-fields/remoteEntry.js?nocache=true',
    bulkActionsApp: 'https://beta.appcdn.leadconnectorhq.com/crm/bulk-actions/remoteEntry.js?nocache=true',
    locationSettingApp: 'https://beta.appcdn.leadconnectorhq.com/revex/LocationSetting/remoteEntry.js?nocache=true',
    copilotApp: 'https://beta.appcdn.leadconnectorhq.com/ai/copilot/remoteEntry.js?nocache=true',
    opportunitiesApp: 'https://beta.appcdn.leadconnectorhq.com/crm/opportunities/remoteEntry.js?nocache=true',
    formSurveyApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true',
    proposalsEstimatesApp: 'https://beta.appcdn.leadconnectorhq.com/leadgen/proposals/remoteEntry.js?nocache=true',
    proposalsEstimateTemplateApp:
      'https://beta.appcdn.leadconnectorhq.com/leadgen/templates/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    crmObjectsSettingsApp:
      'https://beta.appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true',
    usersApp: 'https://beta.appcdn.leadconnectorhq.com/crm/users/remoteEntry.js?nocache=true',
    knowledgeBaseApp: 'https://beta.appcdn.leadconnectorhq.com/ai/knowledge-base/remoteEntry.js?nocache=true',
  },
  production: {
    membershipApp: 'https://appcdn.leadconnectorhq.com/revex/memberships/remoteEntry.js?nocache=true',
    communitiesApp: 'https://appcdn.leadconnectorhq.com/revex/communities-builder/remoteEntry.js?nocache=true',
    goKollabApp: 'https://appcdn.leadconnectorhq.com/revex/gokollab-builder/remoteEntry.js?nocache=true',
    clientPortalBuilder: 'https://appcdn.leadconnectorhq.com/revex/clientportal-builder/remoteEntry.js?nocache=true',
    certificatesApp: 'https://appcdn.leadconnectorhq.com/revex/certificates-builder/remoteEntry.js?nocache=true',
    snapshotsApp: 'https://appcdn.leadconnectorhq.com/revex/snapshots/remoteEntry.js?nocache=true',
    productsApp: 'https://appcdn.leadconnectorhq.com/leadgen/products/remoteEntry.js?nocache=true',
    storeWidgetApp: 'https://appcdn.leadconnectorhq.com/leadgen/store-widgets/remoteEntry.js?nocache=true',
    ecommerceApp: 'https://appcdn.leadconnectorhq.com/leadgen/ecommerce/remoteEntry.js?nocache=true',
    aiEmployeesApp: 'https://appcdn.leadconnectorhq.com/crm/ai-employees/remoteEntry.js?nocache=true',
    marketplaceApp: 'https://appcdn.leadconnectorhq.com/crm/marketplace/remoteEntry.js?nocache=true',
    powerDialerApp: 'https://appcdn.leadconnectorhq.com/revex/power-dialer/remoteEntry.js?nocache=true',
    appointmentModalApp: 'https://appcdn.leadconnectorhq.com/automation/appointment-modal/remoteEntry.js?nocache=true',
    mediaEditorApp: 'https://appcdn.leadconnectorhq.com/leadgen/MediaEditor/remoteEntry.js?nocache=true',
    emailPreviewApp: 'https://appcdn.leadconnectorhq.com/leadgen/email-preview/remoteEntry.js?nocache=true',
    onboardingApp: 'https://appcdn.leadconnectorhq.com/leadgen/Onboarding/remoteEntry.js?nocache=true',
    launchpadApp: 'https://appcdn.leadconnectorhq.com/leadgen/Launchpad/remoteEntry.js?nocache=true',
    calendarSettingsApp: 'https://appcdn.leadconnectorhq.com/automation/calendar-settings/remoteEntry.js?nocache=true',
    calendarServicesApp: 'https://appcdn.leadconnectorhq.com/automation/calendar-services/remoteEntry.js?nocache=true',
    calendarRentalsApp: 'https://appcdn.leadconnectorhq.com/automation/calendar-rentals/remoteEntry.js?nocache=true',
    defaultEmailTemplatesApp: 'https://appcdn.leadconnectorhq.com/leadgen/default-emails/remoteEntry.js?nocache=true',
    contactsApp: 'https://appcdn.leadconnectorhq.com/crm/contacts/remoteEntry.js?nocache=true',
    ghlContactRestoreApp: 'https://appcdn.leadconnectorhq.com/crm/contacts-restore/remoteEntry.js?nocache=true',
    agentStudioApp: 'https://appcdn.leadconnectorhq.com/ai/agent-studio/remoteEntry.js?nocache=true',
    featureDiscoveryApp: 'https://appcdn.leadconnectorhq.com/automation/feature-discovery/remoteEntry.js?nocache=true',
    invoicesApp: 'https://appcdn.leadconnectorhq.com/leadgen/invoices/remoteEntry.js?nocache=true',
    estimatesApp: 'https://appcdn.leadconnectorhq.com/leadgen/estimates/remoteEntry.js?nocache=true',
    leadgenPaymentLinksApp: 'https://appcdn.leadconnectorhq.com/leadgen/payment-links/remoteEntry.js?nocache=true',
    invoicesIntegrationsApp:
      'https://appcdn.leadconnectorhq.com/leadgen/invoices-integrations/remoteEntry.js?nocache=true',
    labsApp: 'https://appcdn.leadconnectorhq.com/crm/labs/remoteEntry.js?nocache=true',
    documentsApp: 'https://appcdn.leadconnectorhq.com/crm/documents/remoteEntry.js?nocache=true',
    customFieldsApp: 'https://appcdn.leadconnectorhq.com/crm/custom-fields/remoteEntry.js?nocache=true',
    bulkActionsApp: 'https://appcdn.leadconnectorhq.com/crm/bulk-actions/remoteEntry.js?nocache=true',
    locationSettingApp: 'https://appcdn.leadconnectorhq.com/revex/LocationSetting/remoteEntry.js?nocache=true',
    copilotApp: 'https://appcdn.leadconnectorhq.com/ai/copilot/remoteEntry.js?nocache=true',
    opportunitiesApp: 'https://appcdn.leadconnectorhq.com/crm/opportunities/remoteEntry.js?nocache=true',
    formSurveyApp: 'https://appcdn.leadconnectorhq.com/leadgen/form-survey/remoteEntry.js?nocache=true',
    proposalsEstimatesApp: 'https://appcdn.leadconnectorhq.com/leadgen/proposals/remoteEntry.js?nocache=true',
    proposalsEstimateTemplateApp: 'https://appcdn.leadconnectorhq.com/leadgen/templates/remoteEntry.js?nocache=true',
    conversationsUtilitiesApp:
      'https://appcdn.leadconnectorhq.com/crm/conversations-utilities/remoteEntry.js?nocache=true',
    crmObjectsSettingsApp: 'https://appcdn.leadconnectorhq.com/crm/crm-objects-settings/remoteEntry.js?nocache=true',
    usersApp: 'https://appcdn.leadconnectorhq.com/crm/users/remoteEntry.js?nocache=true',
    knowledgeBaseApp: 'https://appcdn.leadconnectorhq.com/ai/knowledge-base/remoteEntry.js?nocache=true',
  },
}

let config = remoteConfigEnv[process.env.NODE_ENV as keyof remoteConfigEnv]

if (process.env.NODE_ENV === 'development') {
  // config.clientPortalBuilder = 'http://localhost:3012/remoteEntry.js'
  //  config.appointmentModalApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  //  config.productsApp =  'http://localhost:3041/remoteEntry.js?nocache=true'
  // config.membershipApp = 'http://localhost:4000/remoteEntry.js'
  // config.communitiesApp = 'http://localhost:3050/remoteEntry.js'
  // config.goKollabApp = 'http://localhost:3000/remoteEntry.js'
  // config.aiEmployeesApp = 'http://localhost:3008/remoteEntry.js?nocache=true'
  // config.certificatesApp = 'http://localhost:3004/remoteEntry.js?nocache=true'
  // config.mediaEditorApp = 'http://localhost:10002/remoteEntry.js'
  // config.onboardingApp = 'http://localhost:10004/remoteEntry.js?nocache=true'
  // config.contactsApp = 'http://localhost:3006/remoteEntry.js'
  // config.ghlContactRestoreApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  //  config.onboardingApp = 'http://localhost:10004/remoteEntry.js?nocache=true'
  //  config.launchpadApp = 'http://localhost:10005/remoteEntry.js?nocache=true'
  // config.seoApp = 'http://localhost:3015/remoteEntry.js?nocache=true'
  // config.membershipApp = 'http://localhost:4001/remoteEntry.js'
  // config.communitiesApp = 'http://localhost:3050/remoteEntry.js'
  // config.goKollabApp = 'http://localhost:3000/remoteEntry.js'
  // config.certificatesApp = 'http://localhost:3004/remoteEntry.js?nocache=true'
  // config.certificatesApp = 'http://localhost:3004/remoteEntry.js?nocache=true'
  // config.opportunitiesApp = "http://localhost:3031/remoteEntry.js?nocache=true"
  // config.estimatesApp = 'http://localhost:3007/remoteEntry.js'
  // config.invoicesIntegrationsApp = 'http://localhost:3025/remoteEntry.js?nocache=true'
  // config.invoicesApp = 'http://localhost:3005/remoteEntry.js?nocache=true'
  // config.leadgenPaymentLinksApp = 'http://localhost:3003/remoteEntry.js?nocache=true'
  // config.reportingApp = 'http://localhost:3005/remoteEntry.js?nocache=true'
  // config.mediaCenterApp = 'http://localhost:4040/remoteEntry.js'
  // config.proposalsEstimatesApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  // config.proposalsEstimateTemplateApp = 'http://localhost:3003/remoteEntry.js?nocache=true'
  // config.formSurveyApp = 'http://localhost:3002/remoteEntry.js?nocache=true';
  //config.agentStudioApp = 'http://localhost:3012/remoteEntry.js?nocache=true'
  // config.conversationsUtilitiesApp = 'http://localhost:3002/remoteEntry.js?nocache=true'
  // config.crmObjectsSettingsApp = 'http://localhost:3033/remoteEntry.js?nocache=true'
  // config.usersApp = 'http://localhost:3033/remoteEntry.js?nocache=true'
  // config.knowledgeBaseApp = 'http://localhost:3013/remoteEntry.js?nocache=true'
}

if (process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'development') {
  const microAppsList = (jenkinsConfig.microApps && jenkinsConfig.microApps.split(',')) || []
  config = getStagingVersionedUrl(config, microAppsList, jenkinsConfig.version)
}

if (process.env.NODE_ENV !== 'staging' && process.env.NODE_ENV !== 'development') {
  config = attachAsyncAppsFromManifest(config, process.env.NODE_ENV)
}

export const remoteAppAsyncConfig = config
